import React, { useState, useEffect } from 'react'
import { findIndex, isEmpty } from 'lodash-es'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import SelectedExpert from '../../../../widgets/selectedExpert/SelectedExpert'
import { getSchemaAssignExpert } from '../../../../redux/actions/assignExpert'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ProjectBasicInfoSubProject from '../../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import ProjectBasicInfo from '../../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import ReviewSummaryResultSubProject from '../../../../widgets/reviewSummary/ReviewSummaryResultSubProject'
import { getSubProjectReviewSummary } from '../../../../redux/actions/reviewSummary'

export default function SaveReviewSubproject() {
  const SELECTED_EXPERT = 'selectedExpert'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectReviewSummary(projectId)
      setSchema(_schema)
      //setSchema(mockData.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // let _selectedExpert = []
  // try {
  //   _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  // } catch (e) {}

  const [selectedExpert, setSelectedExpert] = useState([])

  useEffect(() => {
    if (schema?.forms?.ReviewerSelectedList?.itemsList) {
      setSelectedExpert(schema?.forms?.ReviewerSelectedList?.itemsList)
    }
  }, [schema])

  const handleOnClickSelectExpert = (value, checked, data) => {
    console.log('value', value)
    console.log('checked', checked)
    console.log('data', data)
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isSelected = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            ...data,
            // id: data.id,
            // name: data.name,
            // isOnline: data.isOnline,
            isSelected: checked,
            masterReviewerId: data.masterReviewerId || data.id,
          },
        ]
      }
    })
  }

  const handleOnClickOnlineExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isOnline = true
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isOnline = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            ...data,
            id: data.id,
            name: data.name,
            isOnline: checked,
            isSelected: checked,
            masterReviewerId: data.masterReviewerId || data.id,
          },
        ]
      }
    })
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema.forms.ProjectInfo && <ProjectBasicInfoSubProject schema={schema.forms.ProjectInfo} />}
      <br />
      <SelectedExpert
        schema={schema.forms}
        selectedExpert={selectedExpert}
        isSubProject={true}
        onClickSelectExpert={handleOnClickSelectExpert}
        onClickOnlineExpert={handleOnClickOnlineExpert}
        nextEnable={false}
        noButton={schema?.forms?.ReviewApproveAndSummary?.disabled}
      />
      {schema?.forms && (
        <ReviewSummaryResultSubProject
          schema={schema?.forms}
          selectedExpert={selectedExpert}
          requiredSelectedExpert={
            schema?.forms?.ReviewerSelectedList?.conditionOfReviewer?.countOfReviewer || 0
          }
        />
      )}
      <br />
    </SidebarProposal>
  )
}
